document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('bss-video-modal');
  var iframe = document.getElementById('bss-video-iframe');
  var closeBtn = document.getElementById('bss-video-close');

  if (!modal || !iframe) return;

  // Open modal on trigger click
  document.querySelectorAll('.bss-video-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();

      var isMobile = window.innerWidth <= 767;
      var videoUrl = isMobile
        ? trigger.dataset.videoMobile
        : trigger.dataset.videoDesktop;

      if (!videoUrl) return;

      iframe.src = videoUrl;
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  });

  // Close on X button
  closeBtn.addEventListener('click', function() {
    closeModal();
  });

  // Close on backdrop click
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeModal();
    }
  });

  function closeModal() {
    modal.style.display = 'none';
    iframe.src = '';
    document.body.style.overflow = '';
  }
});